module.exports = __webpack_public_path__ + "img/company-templates-2.3016429d.svg";